// EXEMPT
import blitzMessage, { EVENTS } from "@/__main__/ipc-core.mjs";
import { setShowFeedbackModal } from "@/app/actions.mjs";
import type { MenuListItemProps } from "@/app/AppShellMenuListItem.js";
import { hardCodeURLs, LEGAL_PRIVACY_POLICY_HREF } from "@/app/constants.mjs";
import type { GameSymbol } from "@/app/games.mjs";
import { deriveGamesPropMap } from "@/app/games.mjs";
import SymbolMap from "@/util/symbol-map.mjs";

export type GameNavItemMenuCategory = {
  category?: Translation;
  items?: MenuListItemProps[];
};

export type GameNavItem = {
  href: string;
  text: Translation;
  Icon?: SVGComponent;
  menu?: GameNavItemMenuCategory[][];
  tag?: Translation;
  excludeSearch?: boolean;
};

export const GAME_NAV_LINKS = new SymbolMap<
  PartialRecord<GameSymbol, GameNavItem[]>
>({
  ...deriveGamesPropMap("navLinks"),
});

export const FEEDBACK: MenuListItemProps = {
  text: ["common:sendFeedback", "Send Feedback"],
  onClick: () => setShowFeedbackModal(true),
};

export const HELP: MenuListItemProps = {
  text: ["common:navigation.help", "Help"],
  href: hardCodeURLs.BLITZ_SUPPORT,
  target: "_blank",
  // wrong, this should just be a link
  onClick: () => blitzMessage(EVENTS.OPEN_EXTERNAL, HELP.href),
};

export const PRIVACY_POLICY: MenuListItemProps = {
  text: ["home:footer.pp", "Privacy Policy"],
  href: LEGAL_PRIVACY_POLICY_HREF,
};
